import { WhileWorkflowNode } from '@blaze-shared/workflow-domain';

import {
  SchemaProvider,
  WorkflowNodeSchemaProvider,
} from '../../registry/schema-provider.registry';

@WorkflowNodeSchemaProvider('While')
export class WhileNodeSchemaProvider extends SchemaProvider<WhileWorkflowNode> {}
